<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['tweets', 'articles']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Twitter Sentiment</div>
              <v-dialog style="float: right" v-model="twitterSentimentPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Twitter Sentiment</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullTwitterSentimentPieChart'], 'FullTwitterSentimentPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="twitterSentimentPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullTwitterSentimentPieChart" ref="FullTwitterSentimentPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="twitterSentimentPieChart">
                    <TwitterSentimentPieChart v-bind:options="{}" v-bind:filters="getFilters"></TwitterSentimentPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['TwitterSentimentPieChart'], 'TwitterSentimentPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="TwitterSentimentPieChart" ref="TwitterSentimentPieChart" style="height: 100%">
                <TwitterSentimentPieChart v-bind:options="{}" v-bind:filters="getFilters"></TwitterSentimentPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs6>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">News Sentiment</div>
              <v-dialog style="float: right" v-model="newsSentimentPieChart" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">News Sentiment</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullNewsSentimentPieChart'], 'FullNewsSentimentPieChart')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="newsSentimentPieChart = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullNewsSentimentPieChart" ref="FullNewsSentimentPieChart" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="newsSentimentPieChart">
                    <NewsSentimentPieChart v-bind:options="{}" v-bind:filters="getFilters"></NewsSentimentPieChart>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['NewsSentimentPieChart'], 'NewsSentimentPieChart')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="NewsSentimentPieChart" ref="NewsSentimentPieChart" style="height: 100%">
                <NewsSentimentPieChart v-bind:options="{}" v-bind:filters="getFilters"></NewsSentimentPieChart>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Sentiment Timeline</div>
              <v-dialog style="float: right" v-model="articlesAndTweetsSentiment" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Sentiment Timeline</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesAndTweetsSentiment'], 'FullArticlesAndTweetsSentiment')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="articlesAndTweetsSentiment = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesAndTweetsSentiment" ref="FullArticlesAndTweetsSentiment" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="articlesAndTweetsSentiment">
                    <ArticlesAndTweetsSentiment v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsSentiment>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['ArticlesAndTweetsSentiment'], 'ArticlesAndTweetsSentiment')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="ArticlesAndTweetsSentiment" ref="ArticlesAndTweetsSentiment" style="height: 100%">
                <ArticlesAndTweetsSentiment v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsSentiment>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>

      <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Sentiment Map</div>
              <v-dialog style="float: right" v-model="articlesAndTweetsMapSentiment" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Sentiment Map</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesAndTweetsMapSentiment'], 'FullArticlesAndTweetsMapSentiment')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn class='mx-0' icon dark @click.native="articlesAndTweetsMapSentiment = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesAndTweetsMapSentiment" ref="FullArticlesAndTweetsMapSentiment" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top:20px" v-if="articlesAndTweetsMapSentiment">
                    <ArticlesAndTweetsMapSentiment v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsMapSentiment>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn flat icon color="primary" style="float: right; width: 30px" class="mx-0" @click.stop="snap($refs['ArticlesAndTweetsMapSentiment'], 'ArticlesAndTweetsMapSentiment')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 432px;" class="d-flex justify-center align-center">
              <v-card-text id="ArticlesAndTweetsMapSentiment" ref="ArticlesAndTweetsMapSentiment" style="height: 100%">
                <ArticlesAndTweetsMapSentiment v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsMapSentiment>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { snap } from '@/helpers/snapshots'
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import TwitterSentimentPieChart from './charts/TwitterSentimentPieChart.vue'
import NewsSentimentPieChart from './charts/NewsSentimentPieChart.vue'
import ArticlesAndTweetsSentiment from './charts/ArticlesAndTweetsSentiment.vue'
import ArticlesAndTweetsMapSentiment from './charts/ArticlesAndTweetsMapSentiment.vue'

export default {
  data () {
    return {
      expansionValue: 0,
      twitterSentimentPieChart: false,
      newsSentimentPieChart: false,
      articlesAndTweetsSentiment: false,
      articlesAndTweetsMapSentiment: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters']),
    ...mapGetters('toggles', ['getFiltersChips'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap
  },
  components: {
    Filters,
    Counters,
    TwitterSentimentPieChart,
    NewsSentimentPieChart,
    ArticlesAndTweetsSentiment,
    ArticlesAndTweetsMapSentiment
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sentiment.vue